import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import OrderCloseLayout from './layouts/OrderCloseLayout';
import OrderClosePage from './OrderClosePage';

const OrderCloseRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><OrderCloseLayout /></AuthGuard>}>
                <Route index element={<OrderClosePage />} />
            </Route>
        </Routes>
    );
};

export default OrderCloseRoutes;
